




















import Vue from 'vue';

import i18n from '@/i18n';
import api from '@/api';
import { RootActions } from '@/store/types';
import AutocompleteControl, { AutocompletePromise, AutocompleteOption } from '@/components/controls/autocomplete.vue';

export default Vue.extend({
  name: 'PracticeSelectionControl',
  inject: {
    $validator: '$validator',
  },
  components: {
    AutocompleteControl,
  },
  props: {
    value: {
      type: Number,
      default: undefined,
    },
    placeholder: {
      type: String,
      default: i18n.t('Practice'),
    },
    label: {
      type: String,
      default: i18n.t('Practice'),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: 'practice',
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      internalValue: undefined,
      internalLabel: '',
      cancelTokenSource: undefined,
      isLoadingPractice: false,
    };
  },
  computed: {
    autocompleteValue() {
      return {
        label: this.internalLabel,
        value: this.value,
      };
    },
  },
  methods: {
    handleInput(option: AutocompleteOption): void {
      this.internalLabel = option.label;

      let value: number | undefined = Number(option.value);
      if (Number.isNaN(value)) {
        value = undefined;
      }

      if (this.value !== value) {
        this.internalValue = value;
        this.$emit('input', value);
      }
    },
    handleChange(option: AutocompleteOption): void {
      this.internalValue = option.value;
      this.internalLabel = option.label;
      this.$emit('input', Number(option.value));
    },
    loadPracticeName(): void {
      if (this.value === this.internalValue) {
        return;
      }

      if (!this.value) {
        this.internalLabel = '';

        return;
      }

      this.isLoadingPractice = true;
      api.practices
        .get(this.value)
        .then((response) => {
          this.internalLabel = response.data.title;
          this.internalValue = this.value;
          this.isLoadingPractice = false;
        })
        .catch((error) => {
          this.isLoadingPractice = false;
          this.$store.dispatch(RootActions.ERROR, error);
          this.internalLabel = '';
          this.internalValue = undefined;
          this.$emit('input', undefined);
        });
    },
    searchPractice(userInput: string): AutocompletePromise {
      if (this.cancelTokenSource) {
        this.cancelTokenSource.cancel();
        this.cancelTokenSource = undefined;
      }

      if (!userInput) {
        return Promise.resolve({
          results: [],
        });
      }

      this.cancelTokenSource = api.getCancelTokenSource();

      return api.practices.search(userInput, { cancelToken: this.cancelTokenSource.token }).then((response) => {
        return {
          results: response.data.map((item) => ({
            label: item.title,
            value: item.id,
          })),
        };
      });
    },
  },
  watch: {
    value: {
      immediate: true,
      handler() {
        this.loadPracticeName();
      },
    },
  },
});
